export const CMS = () => {
    return <div>CMS</div>
}